// import { Outlet } from 'react-router';
// import './App.css';
// import Header from './component/Header';
// import {Toaster} from 'react-hot-toast';
// import { useEffect } from 'react';
// import { setDataProduct } from './redux/productSlice';
// import { useDispatch } from 'react-redux';

// function App() {
//   const dispatch= useDispatch()
//   // const productData= useSelector((state)=>state.product)
  
//   useEffect(()=>{
//     (async()=>{
//       const res= await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/product`)
//       const resData= await res.json()
      
//       dispatch(setDataProduct(resData))
//     })()
//   })
//   return (
//     <>
//       <Toaster/>

//       <div>
//       <Header/>
//       <main className= 'pt-16 bg-slate-100 min-h-[calc(100vh)]'>
//         <Outlet/>
//       </main>
//       </div>
//     </>
//   );
// }
// export default App;



import { Outlet, useLocation } from 'react-router';
import './index.css';
import Header from './component/Header';
import { Toaster } from 'react-hot-toast';
import { useEffect, useRef } from 'react';
import { setDataProduct } from './redux/productSlice';
import { useDispatch } from 'react-redux';

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const mainRef = useRef(null);

  // Fetch products once on mount
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/product`);
        const resData = await res.json();
        dispatch(setDataProduct(resData));
      } catch (e) {
        console.error('Failed to load products', e);
      }
    })();
  }, []); // eslint-disable-line

  // Page transition: re-trigger animation on route change
  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.classList.remove('animate-page-in');
      void mainRef.current.offsetWidth; // reflow
      mainRef.current.classList.add('animate-page-in');
    }
  }, [location.pathname]);

  return (
    <div className="noise min-h-screen" style={{ background: 'var(--bg-void)' }}>
      <Toaster
        position="top-right"
        gutter={10}
        containerStyle={{ top: 72 }}
        toastOptions={{
          duration: 2800,
          style: {
            background: 'var(--bg-raised)',
            border: '1px solid var(--glass-border)',
            color: 'var(--text-primary)',
            fontFamily: 'var(--font-body)',
            fontSize: '0.875rem',
            borderRadius: '12px',
            boxShadow: 'var(--shadow-glass)',
            backdropFilter: 'blur(20px)',
          },
          success: { iconTheme: { primary: '#00fff0', secondary: 'var(--bg-void)' } },
          error:   { iconTheme: { primary: '#ff4d6d', secondary: 'var(--bg-void)' } },
        }}
      />

      <Header />

      <main
        ref={mainRef}
        className="pt-16 min-h-[calc(100vh-64px)] animate-page-in"
      >
        <Outlet />
      </main>
    </div>
  );
}

export default App;